import { createBrowserHistory } from 'history';
import Config from './config.json'

export default createBrowserHistory({basename: Config.BASE_PATH});
